module.exports = __webpack_public_path__ + "assets/functionalityPlusSmall-aeaf1e.svg";